import { render } from "./InformationProcessId.vue?vue&type=template&id=4b6d2290&scoped=true"
import script from "./InformationProcessId.vue?vue&type=script&lang=js"
export * from "./InformationProcessId.vue?vue&type=script&lang=js"

import "./InformationProcessId.vue?vue&type=style&index=0&id=4b6d2290&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b6d2290"]])

export default __exports__